import React from 'react';
import './Stripe.css';

const Stripe = () => {

    return (
        <div className="stripe">
            <p>Free express shipping on orders over USD 150.00</p>
        </div>
    )
}

export default Stripe